import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3" }
const _hoisted_8 = { class: "fw-bolder text-muted" }
const _hoisted_9 = { class: "min-w-140px" }
const _hoisted_10 = { class: "min-w-140px" }
const _hoisted_11 = { class: "min-w-140px" }
const _hoisted_12 = { class: "text-dark fw-bolder text-hover-primary fs-6" }
const _hoisted_13 = { class: "text-dark fw-bolder text-hover-primary fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h3", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.translate("services")), 1)
      ]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("table", _hoisted_7, [
          _createVNode("thead", null, [
            _createVNode("tr", _hoisted_8, [
              _createVNode("th", _hoisted_9, _toDisplayString(_ctx.translate("name")), 1),
              _createVNode("th", _hoisted_10, _toDisplayString(_ctx.translate("status")), 1),
              _createVNode("th", _hoisted_11, _toDisplayString(_ctx.translate("timestamp")), 1)
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_12, _toDisplayString(item["serviceName"]), 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("span", {
                    class: [`badge-light-${ item['status'] === 'online' ? 'success':'danger' }`, "badge"]
                  }, _toDisplayString(item["status"]), 3)
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_13, _toDisplayString(item["datetime"]), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}